// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { FormLabel, Divider, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 100,
    width: "90%",
  },
  page: {
    padding: 20,
  },
  formLabel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  checkBoxes: {
    color: theme.palette.secondary.main,
  },
  removeFiltersButton: {
    cursor: "pointer",
    textDecoration: "underline",
    bottom: theme.spacing(1),
    color: theme.palette.secondary.main,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginTop: theme.spacing(2),
  },
  formGroup: {
    width: "100%",
  },
}));

const BusinessUnitFilter = ({
  formGroupLabel,
  checkBoxes,
  setCheckboxesState,
  fetchData,
  showHeader = true,
  showAllFilters = true,
}) => {
  const classes = useStyles();

  const handleChange = (originalIndex) => (event) => {
    let checkBoxesCurrent = [...checkBoxes];
    checkBoxesCurrent[originalIndex].isChecked = event.target.checked;

    setCheckboxesState(checkBoxesCurrent);
    fetchData?.();
  };

  const filteredCheckBoxes = checkBoxes
    .map((checkBox, index) => ({ ...checkBox, originalIndex: index }))
    .filter((_, index) => ![2, 4, 5, 6].includes(index));

  const checkedCount = (
    showAllFilters ? checkBoxes : filteredCheckBoxes
  ).filter((checkBox) => checkBox.isChecked).length;

  const handleRemoveFilters = () => {
    const resetCheckBoxes = checkBoxes.map((checkBox) => ({
      ...checkBox,
      isChecked: false,
    }));
    setCheckboxesState(resetCheckBoxes);
    fetchData?.();
  };

  return (
    <React.Fragment>
      {showHeader && (
        <>
          <div className={classes.page}>
            <Grid container spacing={2}>
              <FormGroup row className={classes.formGroup}>
                <FormLabel className={classes.formLabel}>
                  {formGroupLabel}
                </FormLabel>
              </FormGroup>
            </Grid>
          </div>
          <Divider />
        </>
      )}
      <div className={classes.page}>
        <Grid container spacing={2}>
          <FormGroup row className={classes.formGroup}>
            <FormLabel className={classes.formLabel}></FormLabel>
            {(showAllFilters ? checkBoxes : filteredCheckBoxes).map(
              (checkBox, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={checkBox.isChecked}
                      onChange={handleChange(checkBox.originalIndex)}
                      name={checkBox.name}
                    />
                  }
                  label={checkBox.label}
                />
              )
            )}
          </FormGroup>
        </Grid>
        {checkedCount >= 2 && (
          <div className={classes.buttonContainer}>
            <Typography
              className={classes.removeFiltersButton}
              onClick={handleRemoveFilters}
            >
              Remove Filters
            </Typography>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BusinessUnitFilter;
